// extracted by mini-css-extract-plugin
export default {"container":"DN-z","dimension":"EN-z","dimensionLabels":"FN-z"};